import { memo, useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Style from './Toast.module.css';

import { isEmpty } from '../../../utils/generic';
import { useTranslation } from '../../../utils/translate';

let timer = null;
const ERROR_MSG = 'Something went wrong! Try again later';

const img = {
  success: <img alt='Success Icon' height={15} src='/images/check-circle-green.svg' width={15} />,
  error: <img alt='Failed Icon' height={15} src='/images/error-circle.svg' width={15} />
};

const Toast = memo((props) => {
  const { t } = useTranslation();
  const message = isEmpty(props.body) ? ERROR_MSG : props.body;
  const [show, setShow] = useState(props.show);

  useEffect(() => {
    setShow(props.show);

    if (!props.show) {
      return;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      setShow(false);
    }, props.delay);
  }, [props]);

  return (
    show &&
    message && (
      <div
        className={`fixed-bottom ${Style.position} py-3 px-4 text-capitalize white
        font-14 rounded shadow`}
      >
        <div className='d-flex flex-wrap'>
          <div className={`pr-4 ${Style['w-10']}`}>{img[props.type]}</div>
          <div className={Style['w-90']}>{t(message)}</div>
        </div>
      </div>
    )
  );
});

Toast.displayName = 'Toast';

Toast.propTypes = {
  show: PropTypes.bool,
  body: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']),
  delay: PropTypes.number
};

Toast.defaultProps = {
  body: ERROR_MSG,
  show: false,
  type: 'success',
  delay: 4000
};

const mapStateToProps = ({ toast }) => ({
  show: toast.show,
  type: toast.type || 'success',
  body: toast.message || ERROR_MSG,
  delay: toast.delay || 4000
});

export default connect(mapStateToProps, null)(Toast);
